import "../../styles/stores/makeTransactions/initialState.css";
import noTransacteSelectedImage from "./noitemselecteced.png";

const NoTransactionSelected = () => {
  /* require("../../assetsStatic/NoItemSelecteced.png") */
  console.log(process.env.PUBLIC_URL, "assetsStatic/NoItemSelecteced.png");
  return (
    <>
      <div className='noTransactionDiv'>
        <img src={"https://res.cloudinary.com/ebuka1122/image/upload/v1710424163/static%20images%20storelens/noItemSelecteced_whgnaq.png"} />

        <h3>Your Selling Cart is Empty</h3>
        <p>Select a Product to sell</p>
      </div>
    </>
  );
};

export default NoTransactionSelected;
